import React, { Component, PropType } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoadingComponent from '../commonComponents/LoadingComponent'
import NoDataFound from '../commonComponents/NoDataFound'
import { setChartQuestion, setQuestion } from '../../actions/index'

import { Tabs, TabList, DragTab, DragTabList, Tab, PanelList, Panel } from 'react-tabtab';
// import * as customStyle from 'react-tabtab/lib/themes/bulma';
import * as customStyle from '../PinboardComponents/tabs-style/index.normal';
import * as darkStyle from '../PinboardComponents/tabs-style/index.dark';

var questionClicked = false;
var tabClicked = true;
var maxQuestionCount = 6;

class AlfredTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            activeId: 0,
            limitQuestions: true
        };
        this.tabChangeHandle = this.tabChangeHandle.bind(this);
        this.questionObj = this.questionObj.bind(this);
        this.newpage = this.newpage.bind(this);
        this.addMoreButton = this.addMoreButton.bind(this);
        this.eventHandle = this.eventHandle.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ chartSelected: nextProps.chartSelected });
    }
    tabChangeHandle(id) {
        this.setState({
            activeId: id
        })
    }
    newpage = (question, e) => {
        document.getElementById('alfredQue').style.color = "blue"
        var voice = 0;
        var url = "/query?query=" + encodeURIComponent(question) + "&type=ecommerce&voice=" + encodeURIComponent(voice) + "&redirect=1";
        this.props.all_data.props.setQuestion({ "alfred_question": question });
        var win = window.open(url, "_blank");
    }
    eventHandle = (e) => {
        console.log(e);
        this.props.all_data.props.setQuestion({ "alfred_question": e });
        this.props.all_data.props.setChartQuestion({ alfredChartFlag: false})
    }
    addMoreButton(){
        this.setState({
            limitQuestions: !this.state.limitQuestions
        })
    }
    questionObj(intent) {
        var that = this;
        var questionArray = []
        var count = 0;
        this.state.alfredquestion.map(function (question, index) {
            var addQuestion = that.state.limitQuestions && count < maxQuestionCount ? true : (that.state.limitQuestions ? false : true);
            if (question.intent == intent && addQuestion) {
                question = question.question;
                var maskValue = question.length >= 100 ? `${question.substring(0, 100)}...` : question;
                questionArray.push(<div className="col-sm-8 col-lg-4 mg-t-10" key={`${question}_${index}`}>
                    <div className="card card-body alfred-question-height">
                        <div className="aside-alert-link">
                            <i title='Open In New Tab' className='fas fa-external-link-alt desc-btn' data-toggle="tooltip" data-placement="bottom" onClick={that.newpage.bind(that, question)}></i>
                        </div>
                        <span key={`${question}`} id={"alfredQue"} className="alfredQuestion" onClick={jQuery(window).width() >= mobile_width ?that.eventHandle.bind(that, question):that.newpage.bind(that, question)} >{maskValue}</span>
                    </div>
                </div>)
                count++;
            }
        })

        var questionLoadTest = this.state.limitQuestions ? 
                <>{`View More Questions `}<i className="feather" data-feather="arrow-down" key={"arrow-down"} style={{ width: "15px" }} ></i></> :
                <>{`View Less `}<i className="feather" data-feather="arrow-up" key={"arrow-up"} style={{ width: "15px" }} ></i></>

        var moreButton = <div className={`${screen_width>mobile_width ? "row col-md-12 justify-content-around" :"col-sm-8 col-lg-4 mg-t-10"}`} key={`alfredQuestion${this.state.limitQuestions}`}><div className={`${screen_width<=tablet_width ? 'col-md-7' : 'col-md-3'}`}> 
        {/* Alfred more question btn css fix */}
                <div className="card card-body mg-y-10 pd-10 text-center link-03" onClick={this.addMoreButton.bind(this)}>
                    <span data-toggle="tootip" title={"View More Questions"} data-placement="bottom">
                        {questionLoadTest}
                    </span>
                </div>
            </div></div>;
        return <div className="row row-xs justify-content-center">
            {questionArray}
            {moreButton}
        </div>;
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
        feather.replace()
    }
    render() {
        var that = this;

        var tabsList = []; var panelList = []; this.dashboardTabArray = []; var index = 0;

        var icon = { "popular": "fa fa-fire", "trend and pattern": "fas fa-chart-line", "list and break-up": "fa fa-table", "insight analysis": "far fa-lightbulb", "comparison and relationship": "fas fa-arrows-alt", "spike and dip analysis": "fas fa-magic", "trend": "fas fa-chart-line", "summary": "fas fa-tachometer-alt", "compare": "fas fa-arrows-alt", "list/ breakdown": "fa fa-table", "top/ bottom": "fas fa-bar-chart", "relationship": "fas fa-arrows-alt", "insights": "far fa-lightbulb" };

        this.state.intents.map(function (value, index) {

            let temp_icon = icon[value.toLowerCase()];

            tabsList.push(<Tab key={index}><span data-toggle="tooltip" data-placement="bottom" title={value.name}><i className={temp_icon}></i>{` ${value}`}</span></Tab>)
            let questionVar = that.questionObj(value);
            panelList.push(<Panel key={index}>{questionVar}</Panel>)
        });

        let reactTabStyle = SKIN_MODE=="dark" ? darkStyle.default : null;
        reactTabStyle = reactTabStyle ? reactTabStyle : (customStyle.default ? customStyle.default : customStyle);

        return (
            <div className='col-xs-12'>
                <Tabs customStyle={reactTabStyle} onTabChange={this.tabChangeHandle} key={id_dashboard} activeIndex={this.state.activeId}
                    showModalButton={true}
                >
                    <TabList>{tabsList}</TabList>
                    <PanelList>{panelList}</PanelList>
                </Tabs>
            </div>
        );
    }
}

class TextMessage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: null,
            data: props.data,
            val: 6
        };
    }
    handleChangeEvent = (e, type) => {
        tabClicked = true;
        questionClicked = false;
        this.setState({
            chartSelected: e.index
        });
    }
    showMore() {
        chartSelected = this.state.chartSelected == null || this.state.chartSelected == '' && this.state.chartSelected != 0 ? 0 : this.state.chartSelected;
        chartData = this.state.data.data.charts;
        this.setState({
            val: Object.keys(chartData).length
        })
    }
    handleDownload(e, type) {
        var url = '/dashboard/alfred/question';
        url += '?intent=&download=true';
        var win = window.open(url, '_blank');
        win.focus();
    }
    render() {
        var showMore, colorAdd;
        if (typeof this.state.data == 'object') {
            if (this.state.data.data.Intent == null) {
                return (<LoadingComponent />);
            }
            var chartSelected = this.state.chartSelected == null || this.state.chartSelected == '' && this.state.chartSelected != 0 ? 0 : this.state.chartSelected;
            var chartData = this.state.data.data.charts.All;
            var intentData = this.state.data.data.Intent;
            var handleChangeEvent = this.handleChangeEvent;
            var handleChange = this.props.handleChange;
            return (
                <AlfredTabs handleChange={handleChange} intents={intentData} alfredquestion={this.state.data.data.questions} chartSelected={chartSelected} handleChangeEvent={handleChangeEvent} all_data={this.props.all_data} />
            );
        }
        else return (<span>{this.state.data}</span>);
    }
}

class InnerElements extends React.Component {
    getInitialState() {
        return null;
    }
    handleRedirect(value) {
        var path = "/dashboard/charttype?chartCat=" + value;
        if (value == 'Block' && this.props.intent == 'Recommendation')
            path = "/dashboard/recommendation";
        else if (value == 'Block')
            path = "/dashboard/summary";
        else if (value == 'Table')
            path = "/dashboard/report";
        else if (value == 'Stock Chart')
            path = "/dashboard/realtime?chartCat=Line";
        window.open(path, '_blank');
        _paq.push(['trackEvent', 'Chart', value, 'Clicked']);
    }
    render() {
        return (<div className="col-md-2" title={"Visit page for " + this.props.data.name} style={{ marginBottom: '15px' }}>
            <img className='icon-intent' src={this.props.data.img} onClick={this.handleRedirect.bind(this, this.props.data.name)} /><br />
            <div className='text-intent'>{this.props.data.name}</div>
        </div>);
    }
}

class Question extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventHandle: props.eventHandle,
            click: null,
            id: 0,
            alfredquestion: props.alfredquestion
        }
    }
    componentWillReceiveProps(props) {
        this.setState({
            alfredquestion: props.alfredquestion
        })
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }
    handleIdNext = (nextLength, e) => {
        var id = this.state.id;
        if (id == nextLength)
            e.preventDefault();
        else {
            id++;
            this.setState({ id: id, click: 'next' });
        }
    }
    handleIdPrev = (nextLength, e) => {
        var id = this.state.id;
        if (id == 0)
            e.preventDefault();
        else {
            id--;
            if (id < 0)
                id = 0;
            this.setState({ id: id, click: 'prev' });
        }
    }
    newpage = (question, e) => {
        var voice = 0;
        var url = "/query?query=" + encodeURIComponent(question) + "&type=ecommerce&voice=" + encodeURIComponent(voice) + "&redirect=1";
        // this.props.all_data.props.setQuestion({ "alfred_question": question });
        var win = window.open(url, "_blank");
    }
    eventHandle = (e) => {
        console.log(e);
        this.props.all_data.props.setQuestion({ "alfred_question": e });
    }
    render() {
        var intent = this.props.intent;
        var id = this.state.id;
        var click = this.state.click;
        var questionArr = [];
        var temp = [];
        var question;
        var nextLength = null;

        if (this.state.alfredquestion) {
            nextLength = this.state.alfredquestion.length / 6;
            nextLength = nextLength === parseInt(nextLength) ? nextLength - 1 : Math.floor(nextLength);
            this.state.alfredquestion.map(function (value, index) {
                if (index && index % 6 == 0) {
                    questionArr.push(temp);
                    temp = [];
                }
                temp.push(value.question);
            });
            questionArr.push(temp);
            var prev_flag_link = document.getElementById('prev');
            var next_flag_link = document.getElementById('prev');
            var cursorNextStyle = { color: 'blue', cursor: 'pointer' };
            var cursorPrevStyle = { color: 'blue', cursor: 'pointer' };
            var prevIStyle = { marginRight: '3px', color: 'blue' };
            var nextIStyle = { marginLeft: '3px', color: 'blue' };
            var prevClick = this.handleIdPrev.bind(this, nextLength);
            var nextClick = this.handleIdNext.bind(this, nextLength);
            if (id == 0) {
                if (prev_flag_link)
                    prev_flag_link.setAttribute("disabled", "disabled");
                cursorPrevStyle.color = 'rgba(128, 128, 128, 0.64)';
                prevIStyle.color = 'rgba(128, 128, 128, 0.64)';
                cursorPrevStyle.cursor = 'context-menu';
                prevClick = null;
            } else {
                if (prev_flag_link)
                    prev_flag_link.setAttribute("disabled", true);
                var cursorPrevStyle = { color: 'blue', cursor: 'pointer' };
            }
            if (id == nextLength) {
                if (next_flag_link)
                    next_flag_link.setAttribute("disabled", "disabled");
                cursorNextStyle.color = 'rgba(128, 128, 128, 0.64)';
                nextIStyle.color = 'rgba(128, 128, 128, 0.64)';
                cursorNextStyle.cursor = 'context-menu';
                nextClick = null;
            } else {
                if (next_flag_link)
                    next_flag_link.setAttribute("disabled", true);
            }
        }
        if (this.state.alfredquestion == null) {
            if (!questionClicked && tabClicked)
                return (<LoadingComponent />);
        }
        else if (this.state.alfredquestion != 0) {
            if (click == 'next')
                var slideClass = id == 0 ? '' : 'animated slideInRight';
            else if (click == 'prev')
                var slideClass = id >= 0 ? 'animated slideInLeft' : '';
            question = questionArr[id];
            var eventHandle = this.eventHandle;
            var newpage = this.newpage;
            var reactObj = this;
            return (
                <div>
                    <div className={slideClass + " row my-2"}>
                        {
                            question.map(function (Value, index) {
                                if (index >= 3)
                                    var dataPlacement = 'top';
                                else var dataPlacement = 'bottom';
                                var maskValue = Value.length >= 70 ? Value.substring(0, 70) + '...' : Value;
                                return (
                                    <div className="col-sm-8 col-lg-4 mb-2" key={index}>
                                        <div className="card card-body alfred-question-height">
                                            <div className="aside-alert-link">
                                                <i title='Open In New Tab' onClick={newpage.bind(reactObj, Value)} className='fas fa-external-link-alt desc-btn' data-toggle="tooltip" data-placement="bottom"></i>
                                            </div>
                                            <span key={`${Value}`} style={{ cursor: 'pointer' }} title={Value} onClick={newpage.bind(reactObj, Value)} data-placement={dataPlacement} data-toggle="tooltip">{maskValue}</span>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                    <div className="aside-alert-link float-right">
                        <a id='prev' onClick={prevClick} style={cursorPrevStyle}><i className='fa fa-angle-double-left' style={prevIStyle}></i>Prev</a>
                        <a id='next' onClick={nextClick} style={cursorNextStyle}>Next<i className='fa fa-angle-double-right' style={nextIStyle}></i></a>
                    </div>
                </div>);
        }
        else {
            return (<NoDataFound />);
        }
    }
}

class ChatWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            query: ''
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState(nextProps)
    }
    render() {
        var message = null;
        if (this.state.data.data.Intent.length > 0) {
            if (this.state.data.type != 'sample') {
                message = <TextMessage data={this.state.data} handleChange={this.QueryChange} all_data={this} />;
            }
            else message = null;
            return (
                <div>
                    {/* <FeedbackComponent /> */}
                    <div >
                        {/* <AlfredComponent ref="alfredComponentRef" data={this.state} allProps={this}/> */}
                        {message}
                    </div>
                </div>
            );
        } else return null;
    }
}

//export default ChatWindow;

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setQuestion,setChartQuestion
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatWindow)